import { render, staticRenderFns } from "./LayoutWarningLGPD.vue?vue&type=template&id=3d920e04&scoped=true&"
import script from "./LayoutWarningLGPD.vue?vue&type=script&lang=js&"
export * from "./LayoutWarningLGPD.vue?vue&type=script&lang=js&"
import style0 from "./LayoutWarningLGPD.vue?vue&type=style&index=0&id=3d920e04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d920e04",
  null
  
)

export default component.exports